<template>
    <div class="guiji">
        <!-- <el-dialog title="轨迹回放" :visible.sync="guijidialog" :before-close="closeDlg" > -->
        <!-- 车辆动画控制进度条 -->
        <m-title :titlelist="listitem"></m-title>
        <div id="mapTrack" style="height: calc(100% - 50px);">
            <div class="map-title">
                <div>
                    <span>车牌号</span>
                    <input type="text" placeholder="请输入车牌" v-model.trim="inpval" class="inp">
                </div>
                <div>
                    <span>开始时间</span>
                    <el-date-picker v-model="startTime" type="datetime" format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间">
                    </el-date-picker>
                </div>
                <div>
                    <span>结束时间</span>
                    <el-date-picker v-model="endTime" type="datetime" format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间">
                    </el-date-picker>
                </div>
                <button class="search" @click="getmapinfo">搜索</button>
                <button class="search" @click="checkCar">{{ num ? '不随车移动' : '随车移动' }}</button>
                <!-- <button class="search" @click="getTimeCar">点击跳转时间</button> -->
            </div>
            <el-card class="box-card" shadow="never" :body-style="{ padding: '0' }">

                <div id="container" :style="{ 'height': 'calc(100vh - 180' + 'px)' }" > 
                </div>

                <!-- 进度条 -->
                <div class="map-control">
                    <!-- 开始按钮 -->
                    <i v-if="!start" class="el-icon-video-play" style="font-size: 30px;"
                        @click="navgControl(playIcon)"></i>

                    <!-- 暂停按钮 -->
                    <i v-else class="el-icon-video-pause" style="font-size: 30px;" @click="navgControl('pause')"></i>

                    <!-- 开始时间-->
                    <span class="passed-time">{{ passedTime }}</span>
                    <!-- 滑动条修改2个地方 step步长 tip-forma提示框  :tip-format="hideFormat"-->
                    <el-slider class="map-slider" v-model="sliderVal" @change="sliderChange" :step="0.0001"
                        :format-tooltip='hideFormat'>
                    </el-slider>
                    <!-- 倍数 -->
                    <!-- <el-select v-model="times" placeholder="请选择倍速">
                        <el-option
                        v-for="item in speedList"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select> -->
                    <div class="map-times" @mouseenter="isTimesChoose = true" @mouseleave="isTimesChoose = false">
                        <div class="times-show">倍速{{ times }}</div>
                        <div class="choose-box">
                            <ul v-show="isTimesChoose">
                                <li v-for="item in speedList" :key="item" :class="{ active: times == item }"
                                    @click="changeSpeed(item)">倍速
                                    {{ item }}</li>
                            </ul>
                        </div>
                    </div>
                    <!-- 结束 -->
                    <span class="passed-time">{{ totalTime }}</span>
                </div>
            </el-card>
        </div>
        <!-- <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="closeDlg">确 定</el-button>
            </div>
        </el-dialog> -->
        <div class="dlog" v-if="showinfo">
            <div class="left">
                <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange"
                    style="display: flex;flex-wrap: nowrap;justify-content: space-between;">
                    <el-checkbox label="进卡口" style="margin-right: 0px;"></el-checkbox>
                    <el-checkbox label="出卡口" style="margin-right: 0px;"></el-checkbox>
                    <el-checkbox label="过重" style="margin-right: 0px;"></el-checkbox>
                    <el-checkbox label="回皮" style="margin-right: 0px;"></el-checkbox>
                </el-checkbox-group>
                <el-timeline class="timeline" :style="drawer ? 'height:calc(100% - 40px)' : ''">
                    <el-timeline-item v-for="(activity, index) in jcRecordVos" :key="index" 
                        color="#17B6A1" :timestamp="mydateFormat(activity.jcTime,'时分秒')">
                        <div @click="setBackground(activity,index)"
                            :style="backIndex === index ? 'background-color: #EEF7F6;cursor: pointer;border-radius:5px' : 'cursor: pointer;'">
                            {{ activity.jcName }}
                            <input type=checkbox name=chk :value="index" ref="check" @click.stop="getval(activity, index)" :disabled="activity.jcName=='进卡口'||activity.jcName=='出卡口'"
                                v-show="drawer">
                        </div>
                    </el-timeline-item>
                </el-timeline>
                <div class="imgs" v-if="drawer == false">
                    <el-image class="img" :src="url" alt="" ref="elImage" :preview-src-list="srcList" >
                        <div slot="error" style="height: 120px;display: flex;justify-content: center;align-items: center;">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                    <div class="btn">
                        <div class="button" @click="opendiff">
                            图片对比
                        </div>
                        <div class="button" @click="previewImage">
                            查看大图
                        </div>
                    </div>
                </div>
            </div>
            <div class="right" v-if="drawer">
                <div class="button" @click="closeright">收起</div>
                <div class="button1" @click="deffimg">对比图片</div>
                <div class="previewImg">
                    <div class="grid-item" v-for="(item, index) in checktimeList" :key="index">

                        <el-image class="img-item" ref="imgitem" :src="item.url" :preview-src-list="srcListItem" @click="previewImgItem(item.url, index)"></el-image>
                        <div class="checkitem">
                            <div class="item-left">
                                <input type=checkbox name=chk :value="index" ref="checkRight"
                                    @click="getImgItem(item, index)" :disabled="checkImgLise.length >= 2">
                                <div class="time">
                                    <span>{{ item.jcTime.split(' ')[1] }}</span>
                                    <span>{{ item.pno.includes('J')?'前沿':'港俊' }}</span>
                                </div>
                                <span class="miaoshu">{{ item.jcName }}</span>
                            </div>
                            <div class="item-right" @click="previewImgItem(item.url, index)">
                                查看大图
                            </div>
                        </div>

                    </div>

                </div>
            </div>

        </div>
        <el-dialog title="提示" :visible.sync="dialogVisible" width="80%"  :before-close="handleClose">
            <div class="diffImg"> 
                <el-image v-for="(item, index) in checkImgLise" :key="index" :src="item.url"
                    style="width: 49%;height: 100%;"></el-image>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleClose">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<!-- <script src="//webapi.amap.com/ui/1.1/main.js"></script> -->
<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import coordtransform from 'coordtransform'
import mTitle from "@/components/mTitle";
import dayjs from 'dayjs';
window._AMapSecurityConfig = {
    securityJsCode: "78359427ec75b294d1085b283c76a9d7"
};
const MAP_PLUGINS = [
    'AMap.Manager', 'AMap.Scale',
    'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType',
    'AMap.CircleEditor', 'Geocoder', 'Geolocation', 'AMap.MarkerClusterer',
    'AMap.PolyEditor', 'AMap.MouseTool',
    'AMap.Driving', 'AMap.CitySearch', 'AMap.InfoWindow', 'AMap.LngLat',
    'AMap.DistrictSearch', 'AMap.TileLayer.Traffic',
    'AMap.Heatmap', 'AMap.Autocomplete',
    'AMap.PlaceSearch',
    "AMap.ControlBar",
    "AMap.HawkEye",
    "AMap.DrivingRender",
    "AMap.PathNavigator"
]
export default {
    // props: {
    //     guijidialog: {
    //         type: Boolean,
    //         default: false
    //     }
    // },
    components: {
        mTitle,
    },
    data() {
        return {
            listitem: [{ name: "车辆轨迹回放" }],
            // 后台传递来的路线
            linePath: [
            ],
            // 后台传递来的地图上的icon
            icon: [
            ],
            pathList: [],
            // 巡航器
            navgtr: null,
            passedTime: '00:00:00',
            // 总时间
            totalTime: '00:00:00',
            playIcon: 'start', //开始按钮是重新开始还是继续
            speedList: [1, 4, 8, 12, 16, 20,24,28,32],
            times: 1,
            start: false,
            sliderVal: 0,
            isTimesChoose: false,
            map: null,
            plate: "",
            startTime: dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
            endTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            inpval: "",
            num: false,
            belongCarFactory: "",
            checkList: ['进卡口','出卡口','过重','回皮'],
            jcRecordVos:[],
            checkjcRecordVos:[],
            activities: [],
            backIndex: null,
            checktimeList: [],
            drawer: false,
            url:"",
            srcList: [],
            srcListItem: [],
            checkImgLise: [],
            dialogVisible: false,
            endIdx:0,
            pathSimplifierIns:null,
            pno:'',
            showinfo:true
        }
    },
    mounted() {
        if (this.$route.query.plate) {
            this.inpval = this.$route.query.plate
            this.startTime = this.$route.query.startTime ? this.$route.query.startTime : dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss')
            this.endTime = this.$route.query.endTime ? this.$route.query.endTime : dayjs().format('YYYY-MM-DD HH:mm:ss')
            this.pno=this.$route.query.pno
            this.getmapinfo()
        } else {
            this.openDlg()
        }

    },
    methods: {
        handleCheckedCitiesChange(e){
            console.log(e);
            // console.log(this.jcRecordVos);
            // this.jcRecordVos=e.map(i=>{
            //     const find=this.jcRecordVos.filter(j=>j.jcName==i)
            //     return [...find]
            // })
            let finalArr
            finalArr = this.checkjcRecordVos.filter(item => e.includes(item.jcName));
            this.jcRecordVos=finalArr
        },
        handleClose() {
            this.dialogVisible = false
            this.checkImgLise = []
            this.$refs.checkRight.forEach(item => item.checked = false)
        },
        deffimg(){
            if(this.checkImgLise.length<2){
              return  this.$message.error('请选择两张图片进行对比')
            }
            this.dialogVisible = true
        },
        closeright() {
            this.drawer = false
            this.checkImgLise = []
            this.checktimeList=[]
            this.url="" 
            this.$refs.check.forEach(item => item.checked = false)
            this.$refs.checkRight.forEach(item => item.checked = false)
        },
        getImgItem(items, index) {
            if (this.checkImgLise.length >= 2) return
            if (this.$refs.checkRight[index].checked) {
                this.checkImgLise.push(items)
            } else {
                this.checkImgLise = this.checkImgLise.filter(item => item.jcTime != items.jcTime)
               
            }
        },
        previewImgItem(item, index) {
            this.srcListItem = [item]
            this.$nextTick(() => {
                this.$refs.imgitem[index].clickHandler()
            })
        },
        opendiff() {
            this.drawer = true
            this.srcList = []
        },
        previewImage() {
            this.srcList = [this.url]
            this.$nextTick(() => {
                this.$refs.elImage.clickHandler()
            })
        },
       async getval(items, e) {
            let mshurl=await this.getimage(items,'val')
            items.url=mshurl
            if (this.$refs.check[e].checked) {
                this.checktimeList.push(items)
            } else {
                this.checktimeList = this.checktimeList.filter(item => item.jcTime != items.jcTime)
                this.checkImgLise = this.checkImgLise.filter(item => item.jcTime != items.jcTime)
            }
            
        },
        setBackground(item,index) {
            if(this.drawer) return
            if(item.jcName=="进卡口"||item.jcName=="出卡口") return
            this.backIndex = index
            let gotime=dayjs(item.jcTime).valueOf()
            let timeindexof
            timeindexof = this.linePath.findIndex(item => {
                return item.jcTime == gotime
            })
            let val
            val = timeindexof * 100 / this.linePath.length
            this.sliderChange(val)
            this.getimage(item)
        },
        async getimage(item,val){
            const {data:res}=await this.$http(
                "api1",
                "/api/replenish/station/getWeightImage",
                "get",
                {
                    plate: item.plate,
                    time: item.jcTime, 
                }
            )
            if (res.code !== 0) {
                return this.$message(res.msg)
            }
            if(!val){
                this.url=res.data[0]
            }else{
                return res.data[0]
            }
            
        },
        checkCar() {
            this.num = !this.num
           
        },
        async getmapinfo() {
            this.pathList = []
            const { data: res } = await this.$http(
                "api1",
                "/api/replenish/station/carMapLineV2",
                "post",
                {
                    plate: this.inpval,
                    startTime: this.startTime,
                    endTime: this.endTime,
                    pno:this.pno
                }
            )
            if (res.code !== 0) {
                return this.$message(res.msg)
            }
            if (res.data.carMapLineVos.length == 0) {
                return this.$message("未查询到当前车辆的位置信息")
            }
            this.jcRecordVos=res.data.jcRecordVos
            this.checkjcRecordVos=res.data.jcRecordVos
            this.belongCarFactory = res.belongCarFactory
            this.linePath = res.data.carMapLineVos.filter(item => { return item.lon != 0 })
            this.icon[0] = res.data.carMapLineVos[0]
            this.icon[0].icon = require('/public/homeImg/qd_icon.png')
            this.icon[0].label = {
                content: `<div style="font-family: PingFang SC;font-weight: 600;font-size: 16px;color: #c00000; background: transparent">起点</div>`,
                direction: 'top',
            }
            this.icon[1] = res.data.carMapLineVos[res.data.carMapLineVos.length - 1]
            this.icon[1].icon = require('/public/homeImg/zd_icon.png')
            this.icon[1].label = {
                content: `<div style="font-family: PingFang SC;font-weight: 600;font-size: 16px;color: #c00000; background: transparent">终点</div>`,
                direction: 'top',
            }
            this.openDlg()
        },
        async openDlg() {
            const param = {
                // 是否监控地图容器尺寸变化
                resizeEnable: true,
                // 初始地图级别
                zoom: 15
            }
            AMapLoader.reset()
            const AMap = await AMapLoader.load({
                // 高德的key
                key: 'e1e067886b395ac1aa709c2dd9982e7a',
                // 插件集合
                plugin: MAP_PLUGINS,
                // 高德 sdk 版本，默认为 1.4.4
                version: '2.0',
                AMapUI: {
                    plugins: []
                }
            })
            this.map = new AMap.Map('container', param)

            this.init(AMap)

        },
        // closeDlg() {
        //     this.$emit('closeDlog', false)
        // },
        // 滑动条的提示
        hideFormat() {
            return this.passedTime
        },

        // 初始化
        init(AMap) {
            // 后台传递来的数据是json的，所以我们改成数组
            // 轨迹
            // 线条路线
            let linePath = this.linePath
            if (this.belongCarFactory == "吉利") {
                linePath.forEach(item => {
                    // 把json转为数组
                    this.pathList.push([item.lon, item.lat])
                    // 当前时间戳
                    item.stampTime = new Date(item.gmtCreate).getTime()
                    item.jcTime=new Date(item.jcTime).getTime()
                })

                linePath.forEach((item, i) => {

                    // 获得到下一个位置
                    let next = linePath[i + 1]
                    // 判断是否还有下一个
                    if (next) {
                        // 计算出间隔时间 每秒
                        item.intervalTime = (next.stampTime - item.stampTime) / 1000
                        // 计算出下一站
                        item.nextDistance = this.distanceFun(
                            [item.lon, item.lat],
                            [item.lon, item.lat],
                            AMap
                        )
                        // 求出具体的速度
                        item.nextSpeed =
                            item.nextDistance / 1000 / (item.intervalTime / 60 / 60)
                    }
                })

            } else {
                linePath.forEach(item => {
                    // 把json转为数组
                    this.pathList.push(coordtransform.wgs84togcj02(item.lon, item.lat))
                    // 当前时间戳
                    item.stampTime = new Date(item.gmtCreate).getTime()
                    item.jcTime=new Date(item.jcTime).getTime()
                })

                linePath.forEach((item, i) => {

                    // 获得到下一个位置
                    let next = linePath[i + 1]
                    // 判断是否还有下一个
                    if (next) {
                        // 计算出间隔时间 每秒
                        item.intervalTime = (next.stampTime - item.stampTime) / 1000
                        // 计算出下一站
                        item.nextDistance = this.distanceFun(
                            coordtransform.wgs84togcj02(item.lon, item.lat),
                            coordtransform.wgs84togcj02(item.lon, item.lat),
                            AMap
                        )
                        // 求出具体的速度
                        item.nextSpeed =
                            item.nextDistance / 1000 / (item.intervalTime / 60 / 60)
                    }
                })
            }
            // 设置路线
            this.setPath(AMap)

            // 创建起始和经过的icon
            this.icon.forEach(item => {
                this.addIcon(item, AMap)
            })

            // 在init方法加上这行代码
            // 修改全局的路线数据
            this.linePath = linePath
        },
        // 计算两个坐标点之间的距离
        distanceFun(point1, point2, AMap) {
            // 那数组转化为经纬度
            let p1 = new AMap.LngLat(point1[0], point1[1])
            let p2 = new AMap.LngLat(point2[0], point2[1])
            // 计算2点直接的距离  distance这个函数有继续可以了解一下
            let distance = Math.round(p1.distance(p2))
            return distance
        },


        // 格式化时间
        getTime(sTime) {
            let ss
            let mm = '00'
            let hh = '00'
            if (sTime > 60) {
                let s = sTime % 60
                ss = s > 9 ? s : '0' + s
                let mTime = parseInt(sTime / 60)
                if (mTime > 60) {
                    let m = mTime % 60
                    mm = m > 9 ? m : '0' + m
                    hh = parseInt(mTime / 60)
                } else {
                    mm = mTime > 9 ? mTime : '0' + mTime
                }
            } else {
                ss = sTime > 9 ? sTime : '0' + sTime
            }
            return hh + ':' + mm + ':' + ss
        },
        // 滑动条改变事件
        sliderChange(val) {
            // 计算开始距离
            let num = parseInt((val / 100) * this.pathList.length)
            // 计算结束的距离
            let decimal =
                String((val / 100) * this.pathList.length).split('.')[1] || 0
            // 移动小车
            this.navgtr.moveToPoint(num, Number('0.' + decimal))
            // 重新绘制
            this.pathSimplifierIns.renderLater()
        },

        // 设置路线
        setPath(AMap) {
            let that = this

            AMapUI.load(['ui/misc/PathSimplifier', 'lib/$'],  (
                PathSimplifier
            )=> {
                if (!PathSimplifier.supportCanvas) {
                    alert('当前环境不支持 Canvas！')
                    return
                }
                if (window.pathSimplifierIns && that.pathSimplifierIns) {
                //通过该方法清空上次传入的轨迹
                that.pathSimplifierIns.setData([]);
              }
                function onload() {
                    that.pathSimplifierIns.renderLater()
                }
                function onerror() {
                    console.log('图片加载失败！')
                }
                // let route=[{path: that.pathList.slice(0,2000),color:'red',},{path: that.pathList.slice(2000,4000),color:'green',},{path: that.pathList.slice(4000),color:'blue',}]
                var colors = ["green", "red", "green",'blue','black']
                // 历史轨迹巡航器
                that.pathSimplifierIns = new PathSimplifier({
                    zIndex: 100,
                    map: that.map, // 所属的地图实例
                    getPath: function (pathData) {
                        // 这里的pathData保存的是路线
                        return pathData.path
                    },
                    // 自动设置视图
                    autoSetFitView: true,
                    // // 巡航器样式
                    renderOptions: {
                        // 路径导航样式
                        pathNavigatorStyle: {
                            // 一开始小车的旋转角度
                            initRotateDegree: 0,
                            // 小车的宽
                            width: 20,
                            // 小车的高
                            height: 32,
                            // 自动旋转
                            autoRotate: true,
                            // 折线拐点连接处样式
                            lineJoin: 'round',
                            // PathSimplifier提供了一个快捷方法用于创建图片内容的content（function）：
                            // 图片地址
                            // 图片加载成功，重新绘制一次 onload方法
                            // 图片加载失败 onerror方法
                            content: PathSimplifier.Render.Canvas.getImageContent(
                                'https://webapi.amap.com/images/car.png',
                                onload,
                                onerror
                            ),
                            // 这个位置提示一下 因为我们用的是图片所以看不见效果
                            // 想看见效果删除上面的content
                            // 他是一个三角形 这里就是设置边框颜色和内部颜色的
                            // 填充色
                            fillStyle: null,
                            // 描边色
                            strokeStyle: null,
                            // 边的宽度
                            lineWidth: 1,
                            // 巡航器经过的路径的样式
                            pathLinePassedStyle: {
                                lineWidth: 6,
                                strokeStyle: 'skyblue',
                                dirArrowStyle: {
                                    stepSpace: 15,
                                    strokeStyle: '#FFF'
                                }
                            }
                        },
                        // getPathStyle: function (pathItem, zoom) {
                        //     that.getNewArray(pathItem.pathData.path,2000,5000)
                        //     var color = colors[pathItem.pathIndex % colors.length]
                        //     return {
                        //         pathLineStyle: {
                        //             strokeStyle: color,
                        //             lineWidth: 5
                        //         },
                        //     }
                        // },
                        // 线条样式
                        pathLineStyle: {
                            lineWidth: 6,
                            strokeStyle: 'green',
                            borderWidth: 1,
                            borderStyle: '#eeeeee',
                            dirArrowStyle: false
                        },
                        // 鼠标移入之后线条的样式
                        pathLineHoverStyle: {
                            lineWidth: 6,
                            strokeStyle: '#ff0000',
                            borderWidth: 1,
                            borderStyle: '#cccccc',
                            dirArrowStyle: false
                        },
                        // 鼠标单击之后线条的样式
                        pathLineSelectedStyle: {
                            lineWidth: 6,
                            borderWidth: 1,
                            strokeStyle: 'blue',
                            borderStyle: '#cccccc',
                            dirArrowStyle: true
                        },
                        pathTolerance: 2,
                        keyPointTolerance: 0,
                        renderAllPointsIfNumberBelow: 0 // 绘制路线节点，如不需要可设置为-1
                    }
                })
                // 历史轨迹巡航器设置数据 这里设置的就是上面pathData的数据
                that.pathSimplifierIns.setData([
                    {
                        name: '轨迹',
                        path: that.pathList
                    },
                    // {.slice(0, 1000)
                    //     name: '轨迹',
                    //     path: that.pathList.slice(1000, 3000)
                    // },
                    // {
                    //     name: '轨迹',
                    //     path: that.pathList.slice(3000,4000)
                    // },
                    // {
                    //     name: '轨迹',
                    //     path: that.pathList.slice(4000,5000)
                    // },
                    // {
                    //     name: '轨迹',
                    //     path: that.pathList.slice(5000,6000)
                    // }
                ])

                // 开启中心自适应
                that.pathSimplifierIns.setFitView(-1)

                // 获取初始速度
                // 设置默认的为 0.1
                let startSpeed = 20
                if (that.linePath.length !== 0) {
                    // 获取一开始的速度 并且判断是否为0 如果不为0直接返回 为0给一个初始的速度
                    startSpeed =
                        that.linePath[0].nextSpeed === 0 ? 20 : that.linePath[0].nextSpeed
                }
                // 对第一条线路（即索引 0）创建一个巡航器
                that.navgtr = that.pathSimplifierIns.createPathNavigator(0, {
                    loop: false, // 循环播放
                    // 速度×倍速
                    speed: startSpeed * that.times,
                })
                let linePath = that.linePath
                let len = linePath.length
                let startPoint = linePath[0]
                let endPoint = linePath[len - 1]

                // 计算总时间，hh:mm:ss 因为计算出来是时间搓 所以要进行格式化
                that.totalTime = that.getTime(
                    (endPoint.stampTime - startPoint.stampTime) / 1000
                )

                // 创建 infoWindow 实例
                let infoWindow = new AMap.InfoWindow({
                    anchor: 'bottom-center',
                    autoMove: false,
                    offset: new AMap.Pixel(0, -20),
                    content: ''  //传入 dom 对象，或者 html 字符串
                })
                // that.map.setFitView(null, false);
                // 移动过程中
                that.navgtr.on('move', function (e) {
                    if (that.num) {
                        that.map.on('zoomstart',function(e){
                            that.navgControl('pause')
                        })
                        that.map.on('zoomend',function(e){
                            that.navgControl('resume')
                            // that.navgtr.resume()
                        })
                        that.map.setCenter(e.target.getPosition())
                    }

                    that.playIcon = 'resume'
                    // 走到了第几个点
                    let idx = this.getCursor().idx
                    // 至下一个节点的比例位置
                    let tail = this.getCursor().tail
                    // 总路程
                    let totalIdx = idx + tail
                    // 计算下一个距离速度
                    let point = linePath[idx]
                    if (idx < len - 1) {
                        // 判断速度是否为0 如果为0 需要给个0.1的速度
                        point.nextSpeed === 0 && (point.nextSpeed = 20)
                        // 这里的速度记得×倍数
                        that.navgtr.setSpeed(point.nextSpeed * that.times)
                    }
                    // 剩余公里数，窗体随时移动展示
                    // 判断是否还有下一个点和时间
                    point &&
                        point.gmtCreate &&
                        infoWindow.setContent(
                            `<p class="info-window">时间：<span>${point.gmtCreate}</span></p>`
                        )
                    // 设置提示框
                    infoWindow.open(that.map, that.navgtr.getPosition())
                    // 进度条实时展示tail
                    !that.isOnSlider && (that.sliderVal = (totalIdx / len) * 100)
                    // 已经播放时间
                    let sTime = parseInt(
                        (((endPoint.stampTime - startPoint.stampTime) / 1000) *
                            that.sliderVal) /
                        100
                    )
                    // 格式化时间
                    that.passedTime = that.getTime(sTime)
                    // 如果到头了，回到初始状态
                    if (that.navgtr.isCursorAtPathEnd()) {
                        // 设置为开始状态 让小车回到原来位置
                        that.playIcon = 'start'
                        // 设置图标状态
                        that.start = false
                        // 设置已经走过的时间
                        that.passedTime = that.totalTime
                        // 设置滑动条状态
                        that.sliderVal = 100
                    }

                })

                
            })
        },
        getNewArray(arr,start,end){
            let newArray=[]
            newArray[0]=arr.slice(0,start)
            newArray[1]=arr.slice(start,end)
            newArray[2]=arr.slice(end)
            return newArray
        },
        expandPath() {
            let that=this
            let data1=[{
                        name: '轨迹',
                        path: that.pathList.slice(0, 1000)
                    },]
            let doExpand=()=> {
                that.endIdx++;

                if (that.endIdx >= that.pathList.length) {
                    return false;
                }

                var cursor = that.navgtr.getCursor().clone(), //保存巡航器的位置
                    status = that.navgtr.getNaviStatus();


                    data1[0].path = that.pathList.slice(0, that.endIdx + 1000);
                    that.pathSimplifierIns.setData(data1); //延展路径


                //重新建立一个巡航器
                that.navgtr = that.pathSimplifierIns.createPathNavigator(0, {
                    //loop: true, //循环播放
                    speed: 600000 //巡航速度，单位千米/小时
                });

                if (status !== 'stop') {
                    that.navgtr.start();
                }

                //恢复巡航器的位置
                if (cursor.idx >= 0) {
                    that.navgtr.moveToPoint(cursor.idx, cursor.tail);
                }

                return true;
            }

            if (doExpand()) {

                setTimeout(that.expandPath, 1000);
            }
        },

        addIcon(item, AMap) {
            // 设置每个icon的内容
            if (this.belongCarFactory == '吉利') {
                const marker = new AMap.Marker({
                    // 图片
                    icon: item.icon,
                    // 位置
                    // title: item.title,
                    // label:item.label,
                    position: [item.lon, item.lat],
                    //设置基点偏移
                    offset: new AMap.Pixel(-13, -30),

                })
                // 把图标放在地图上
                marker.setMap(this.map)
            } else {
                const marker = new AMap.Marker({
                    // 图片
                    icon: item.icon,
                    // 位置
                    // label:item.label,
                    // title: item.title,
                    position: coordtransform.wgs84togcj02(item.lon, item.lat),
                    //设置基点偏移
                    offset: new AMap.Pixel(-13, -30),

                })
                // 把图标放在地图上
                marker.setMap(this.map)
            }

        },
        // 暂停和播放按钮
        navgControl(action) {
            if (action === 'start') {
                let that = this
                this.passedTime = '00:00:00'
                setTimeout(() => {
                    that.navgtr[action]()
                }, 300)
            } else {
                this.navgtr[action]()
            }
            // 修改图标状态
            this.start = !this.start
        },

        // 修改速度
        changeSpeed(item) {
            this.times = item
            this.isTimesChoose = false
        },
    },

}
</script>

<style lang="scss" scoped>
// 设置图标大小
::v-deep.amap-icon img {
    width: 25px;
    height: 34px;
}

.diffImg {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.guiji {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;

    .dlog {
        position: absolute;
        left: 30px;
        top: 120px;
        border-radius: 8px;
        z-index: 999;
        height: calc(100vh - 240px);
        // width: calc(100vw - 250px);
        display: flex;
        justify-content: flex-start;

        .left {
            width: 280px;
            height: 100%;
            overflow: auto;
            padding: 10px;
            box-sizing: border-box;
            background-color: #fff;

            .timeline {
                margin-top: 20px;
                height: calc(100% - 180px);
                overflow: auto;
                padding-top: 5px;
            }

            .imgs {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 280px;
                padding: 0 20px;
                box-sizing: border-box;
                height: 150px;

                .img {
                    width: 100%;
                    height: 120px;
                    
                }

                .btn {
                    display: flex;
                    justify-content: space-evenly;
                    align-items: center;
                    color: #fff;

                    .button {
                        padding: 5px 15px;
                        font-size: 80%;
                        background: #17B6A1;
                        border-radius: 4px;
                        cursor: pointer;
                    }

                }
            }
        }

        .right {
            height: 100%;
            width: calc(100vw - 600px);
            background-color: #fff;
            padding: 10px;
            box-sizing: border-box;
            position: relative;

            .button {
                padding: 5px 15px;
                font-size: 80%;
                background: #17B6A1;
                color: #fff;
                border-radius: 4px;
                position: absolute;
                top: 10px;
                right: 10px;
                cursor: pointer;
            }

            .button1 {
                padding: 5px 15px;
                font-size: 80%;
                background: #17B6A1;
                color: #fff;
                border-radius: 4px;
                position: absolute;
                top: 10px;
                right: 80px;
                cursor: pointer;
            }

            .previewImg {
                margin-top: 40px;
                width: 100%;
                display: grid;
                grid-template-columns: repeat(4, 24%);
                grid-row-gap: 10px;
                justify-content: space-between;

                .grid-item {
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;

                    .img-item {
                        height: 120px;
                    }

                    .checkitem {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        .item-left {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;

                            .time {
                                display: flex;
                                flex-direction: column;
                                justify-content: flex-start;
                                font-size: 80%;
                                margin-left: 2px
                            }

                            .miaoshu {
                                font-size: 80%;
                                margin-left: 2px
                            }
                        }

                        .item-right {
                            padding: 5px 15px;
                            font-size: 80%;
                            background: #17B6A1;
                            color: #fff;
                            border-radius: 4px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }

    .map-title {
        position: absolute;
        top: 60px;
        left: 30px;
        padding: 10px;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background-color: #fff;
        z-index: 33;

        .inp {
            padding: 10px;
            border: none;
            outline: none;
            background-color: #F8F9FB;
        }

        .search {
            margin-left: 20px;
            // width: 80px;
            padding: 0 20px;
            height: 30px;
            background: #17B6A1;
            border-radius: 8px;
            font-size: 80%;
            font-family: PingFang SC;
            font-weight: 400;
            color: #fff;
            text-align: center;
            // line-height: 32px;
            border: none;
        }
    }

    .map-control {
        // 绝对定位
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 65px;
        line-height: 65px;
        color: #fff;
        background-image: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
        padding: 0 40px;
        box-sizing: border-box;
        z-index: 33;

        // 设置按钮大小
        .play-icon {
            font-size: 36px;
        }

        // 设置时间样式
        .passed-time {
            // 相对定位
            position: relative;
            // 转为行内元素
            display: inline-block;
            top: 1px;
            margin-left: 15px;
            font-size: 14px;
        }

        // 进度条样式
        .map-slider {
            // 转为行内元素
            display: inline-block;
            width: 75%;
            margin-left: 15px;
            position: relative;
            top: 14px;
        }

        // 修改默认的进度条样式
        .choose-box {
            // 相对定位
            position: absolute;
            top: -265px;
            left: -6px;
            height: 200px;
            // overflow: auto;
            // 过滤
            transition: all 0.5s linear;
        }

        // 倍数
        .map-times {
            display: inline-block;
            position: relative;
            margin-left: 15px;

            // 倍速样式
            .times-show {
                padding: 0 10px;
                line-height: 24px;
                font-size: 13px;
                border: 1px solid #fff;
                border-radius: 4px;
                // 鼠标设置为默认样式
                cursor: default;
            }

            // 倍数
            ul {
                background: rgba(0, 0, 0, 0.7);
                padding: 10px;
                width: 70px;
                text-align: center;
                border-radius: 3px;
                list-style: none;

                li {
                    height: 26px;
                    line-height: 26px;
                    cursor: pointer;
                }

                li.active {
                    color: #ff8533;
                }

                li:hover {
                    font-size: 13px;
                }
            }
        }
    }

}

// 设置循环器样式</style>